import { Component } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'demo-upp-application',
    templateUrl: './demo-upp-application.html',
    styleUrls: ['../demo-common.scss', './demo-upp-application.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoUppApplicationComponent {
    menuMode: 'show' | 'hide' = 'show';
    activeNav = 'dashboard';

    navItems = [
        { id: 'dashboard', label: 'Dashboard', icon: 'grid-outline' },
        { id: 'products', label: 'Products', icon: 'pricetag-outline' },
        { id: 'orders', label: 'Orders', icon: 'receipt-outline' },
        { id: 'settings', label: 'Settings', icon: 'settings-outline' }
    ];

    toggleMenu() {
        this.menuMode = this.menuMode === 'show' ? 'hide' : 'show';
    }

    selectNav(id: string) {
        this.activeNav = id;
    }
}
